<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: 0,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.orgStatus === 'Y' ? 'light' : 'warning'">
          {{ row.v_orgStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('btn_delete_sample') || '删除样品'"
          placement="top"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 70,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: this.$l('INDEX.sample_style_no') || '样品款号',
          field: 'sampleStyleNo',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.sample_barcode') || '样品条码',
          field: 'sampleBarcode',
          minWidth: 160,
          fixed: 'left',
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.sample_name') || '样品名称',
          field: 'sampleName',
          minWidth: 350,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          // showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('form_label_stock_qty') || '库存数量',
          field: 'invNum',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('form_label_stock_location_no') || '存放库位',
          field: 'locationNo',
          minWidth: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.stock_form_location_desc') || '库位说明',
          field: 'locationDescription',
          minWidth: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.form_label_change_time') || '变动时间',
          field: 'modifyDate',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.form_label_change_business_desc') || '变动业务说明',
          field: 'modifyDescription',
          minWidth: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
      ],
    }
  },
  methods: {
    delRow(row) {
      const { tableData = [] } = this.$refs.table.getTableData()
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i]._XID == row._XID) {
          this.$emit('delRow', i)
          return
        }
      }
    },
  },
}
</script>
